export type MediaContext = { scope: 'unit' } | { scope: 'client'; clientId: string };

export function mediaBasePath(ctx: MediaContext): string {
  return ctx.scope === 'client' ? `/clients/${ctx.clientId}/media` : '/media';
}

export function groupsBasePath(ctx: MediaContext): string {
  return ctx.scope === 'client' ? `/clients/${ctx.clientId}/groups` : '/groups';
}
